import { useState } from 'react';
import { useApi } from '../lib/useApi';
import { qs } from '../lib/api';
import { money, num } from '../lib/format';
import { Loader } from '../ui/common';

export default function SalesTax({ config }) {
  const currency = config.currency || '₹';
  const [year, setYear] = useState(config.startYear || new Date().getFullYear());
  const { data, loading, error } = useApi(`/api/sales-tax${qs({ year })}`);
  const now = new Date().getFullYear();
  const years = [];
  for (let y = now + 1; y >= now - 6; y--) years.push(y);

  return (
    <div>
      <div className="cm-form-section-card">
        <div className="cm-field-group">
          <label>Select Financial Year</label>
          <select value={year} onChange={(e) => setYear(Number(e.target.value))}>
            {years.map((y) => <option key={y} value={y}>{y}</option>)}
          </select>
        </div>
      </div>

      {error && <div className="err" style={{ marginBottom: 16 }}>{error}</div>}
      {loading || !data ? <Loader /> : (
        <>
          <div className="cm-ref-stats-row">
            <div className="cm-ref-stat-card">
              <div className="cm-ref-stat-label">TOTAL TAX COLLECTED</div>
              <div className="cm-ref-stat-val" style={{ color: 'var(--brand)' }}>{money(data.totalCollected, currency)}</div>
            </div>

            <div className="cm-ref-stat-card">
              <div className="cm-ref-stat-label">TOTAL TAX PAID</div>
              <div className="cm-ref-stat-val" style={{ color: 'var(--ink)' }}>{money(data.totalPaid, currency)}</div>
            </div>

            <div className="cm-ref-stat-card">
              <div className="cm-ref-stat-label">NET TAX DIFFERENCE</div>
              <div className="cm-ref-stat-val" style={{ color: data.difference >= 0 ? '#224eae' : '#0f172a' }}>
                {money(data.difference, currency)}
              </div>
            </div>
          </div>

          <div className="cm-table-card" style={{ marginTop: 20 }}>
            <div style={{ padding: '16px 20px', fontWeight: 800, fontSize: '0.95rem', color: 'var(--ink)', borderBottom: '1px solid #e2e8f0' }}>
              Monthly Sales Tax Breakdown ({year})
            </div>
            <table className="cm-table">
              <thead>
                <tr><th>Month</th><th>Tax Collected</th><th>Tax Paid</th><th>Net Payable / Difference</th></tr>
              </thead>
              <tbody>
                {data.months.map((m) => (
                  <tr key={m.month}>
                    <td style={{ fontWeight: 800 }}>{m.month}</td>
                    <td style={{ fontWeight: 700, color: 'var(--brand)' }}>{num(m.collected)}</td>
                    <td style={{ fontWeight: 700, color: 'var(--ink)' }}>{num(m.paid)}</td>
                    <td style={{ fontWeight: 800, color: m.difference >= 0 ? '#224eae' : '#0f172a' }}>
                      {num(m.difference)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
